export const SnackBarAutoDismissDurationMS = 4000;
